import StatusBadge from './StatusBadge';

const BORDER_COLOR = {
  urgente:  '#991B1B',
  pendente: '#854F0B',
};

function initials(nome) {
  if (!nome) return '?';
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export default function ConversaItem({ conversa, onClick }) {
  const { paciente_nome, status, slots = {}, medico_nome, especialidade } = conversa;

  const borderColor = BORDER_COLOR[status] ?? 'transparent';

  const subtitleParts = [medico_nome, especialidade, slots.convenio].filter(Boolean);

  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 12px',
        borderLeft: `3px solid ${borderColor}`,
        cursor: 'pointer',
        transition: 'background-color 0.15s',
      }}
      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F8F9FA'}
      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
    >
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#F1F3F5',
        color: '#6C757D',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: 600,
        flexShrink: 0,
      }}>
        {initials(paciente_nome)}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
          <span style={{ fontSize: '13px', fontWeight: 500, color: '#1A1A2E', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {paciente_nome}
          </span>
          <StatusBadge status={status} />
        </div>
        <p style={{ fontSize: '12px', color: '#6C757D', margin: '2px 0 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {subtitleParts.join(' · ') || ' '}
        </p>
      </div>

      <span style={{ color: '#ADB5BD', fontSize: '14px', flexShrink: 0 }}>›</span>
    </div>
  );
}
